import type { ReactElement } from "react";

export interface ConditionalWrapperProps {
    children: ReactElement;
    condition?: boolean;
    wrapper: (children: ReactElement) => ReactElement;
}

export const ConditionalWrapper = ({
    children,
    condition = false,
    wrapper,
}: ConditionalWrapperProps) => (condition ? wrapper(children) : children);
